import { Handle, Position } from "reactflow";
import { CSSProperties, memo } from "react";
import { useStore } from "reactflow";
import { useConditionHandle } from "./useConditionHandle";
import { ConditionHandleProps } from "./types.d";

const ConditionHandle = ({
  handleId,
  isActive = false,
  activeColor,
  type,
  position = Position.Left,
  left = -16,
  right = -33,
  top = "10px",
}: ConditionHandleProps) => {
  const { baseStyle, visualStyle, handleMouseEnter, handleMouseLeave } =
    useConditionHandle({
      handleId,
      isActive,
      activeColor,
      type,
      position,
    });

  const isDraggingConnection = useStore((s) => s.connectionNodeId !== null);

  const positionStyle: CSSProperties = {
    top,
    left: position === Position.Left ? left : "unset",
    right: position === Position.Right ? right : "unset",
  };

  return (
    <Handle
      id={handleId}
      type={type}
      position={position}
      style={{ ...baseStyle, ...positionStyle }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={visualStyle} />
      {/* Expanded hit area for easier mouse targeting during drag */}
      <div
        style={{
          position: "absolute",
          width: "36px",
          height: "36px",
          backgroundColor: "transparent",
          borderRadius: "50%",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: -1,
          pointerEvents: isDraggingConnection ? "auto" : "none",
        }}
      />
    </Handle>
  );
};

export default memo(ConditionHandle);
